import Splide from '@splidejs/splide';
import { index_search_loadMore, send_genieSummaryFeedback  } from './page-scripts/index_scripts';
// require('jqueryui');
import { favorite_campsite, unfavorite_campsite_fromIcon } from './util/favorite_campsite';
import { send_getLikedCamps, send_getNearbyCamps, send_getTopCamps, send_getTopSponsoredCamps } from './util/search_api';

import { sort_camp_card_list } from './util/filter_campsites';
import { initCardedTrialArtifact, initCookieChoice, initLD, initializeTooltips, sleep, waitFor, getAllFeatureFlags, mi_to_meter, meter_to_mi, check_driveTimeStr_getNum } from './util/general_util';
import { addMarker_googleMap, initMap_googleMaps } from './tripPlanner/tripPlanner_util/tripPlanner_g_map_util';

import { reverseGeocode, submit_missingCampground } from './util/user_api';
import { freemiumShowSignup, freemiumShowSubscribe } from './util/dependentOnFeatureFlags';
import { StopByStopTrip_autofill } from './util/autofill_scripts';
import { takeGenieTrip_log } from './log';




// var Countdown = require('countdown-js')

$(function(){
  initCardedTrialArtifact();
	initCookieChoice();
  setRandomHook();

  if (window.appInsights) {
    const originalConsoleError = console.error;
    console.error = function(...args) {
      originalConsoleError.apply(console, args);
      const error = args.find(arg => arg instanceof Error) || new Error(args.map(arg => JSON.stringify(arg)).join(' '));
      window.appInsights.trackException({ exception: error });
    }
  };

  // const saleCountdown = $("#saleCountdown");
  // if (saleCountdown.length) {
  //   var sale_end_date:string = $("#saleEndDate").val().toString();
  //   const targetDate = new Date(sale_end_date + "T23:59:59");
  //   const timer = Countdown.timer(targetDate, function(timeLeft:any) {
  //     var days:number = timeLeft.days;
  //     var hours:number = timeLeft.hours;
  //     var minutes:number = timeLeft.minutes;
  //     var seconds:number = timeLeft.seconds;

  //     var saleCountdownText:string;

  //     if (days > 0){
  //       saleCountdownText = `Only ${days.toString()} days and ${hours.toString()} hours left!`;
  //     }else if (hours > 0){
  //       saleCountdownText = `Only ${hours.toString()} hours and ${minutes.toString()} minutes left!`;
  //     }else if (minutes > 0){
  //       saleCountdownText = `Only ${minutes.toString()} minutes and ${seconds.toString()} seconds left!`;
  //     }else{
  //       saleCountdownText = `Only ${seconds.toString()} seconds left!`;
  //     }

  //     //saleCountdownText = `${days.toString().padStart(2,"0")}:${hours.toString().padStart(2,"0")}:${minutes.toString().padStart(2,"0")}:${seconds.toString().padStart(2,"0")}`

  //     /*
  //     saleCountdownText = days > 1? `${days} days` : days > 0? `${days} day` : '';
  //     saleCountdownText += hours == 1? ' 1 hour' : ` ${hours} hours`
  //     saleCountdownText += minutes == 1? ' 1 minute': ` ${minutes} minutes`
  //     saleCountdownText += seconds == 1? ' 1 second': ` ${seconds} seconds`
  //     */
  //     saleCountdown.html(saleCountdownText);
  //   });
  // };
});

let timeoutId: ReturnType<typeof setTimeout>;


$(document).on("click", ".cgCardTab", function(event: Event) {
  // Get the anchor inside the clicked .cgCardTab
  let clickedAnchor = $(this).find('a');

  // Activate the clicked tab
  clickedAnchor.tab('show');

  // Update the classes for all .cgCardTab elements
  $('.cgCardTab').each(function() {
      let nearestAnchor = $(this).find('a');
      if (nearestAnchor.hasClass('active')) {
          $(this).removeClass('cgCardTabInactive');
      } else {
          $(this).addClass('cgCardTabInactive');
      }
  });
});

$('#threeFeaturesCollapse').on('show.bs.collapse', async function () {
  $('a[href="#threeFeaturesCollapse"]').text('See Less Features');
  $('a[href="#threeFeaturesCollapse"]').removeClass('btn-primary-outline');
  $('a[href="#threeFeaturesCollapse"]').addClass('btn-agBlue-outline');
  await waitFor(.25);
  $("#gjBetaBadge").removeClass("d-none");
  $('a[href="#threeFeaturesCollapse"]').addClass('d-none');
});

function setRandomHook() {
  const hooks: string[] = [
      "Make Every Mile Count - Start Your Journey Now!",
      "Embrace the Detours - Your Adventure Begins Here!",
      "Find Your Wild - Begin Today!",
      "Unfold New Paths - Embark Now!",
      "Life's Short, Roads Are Long - Start Exploring!",
      "Ready, Set, Adventure - Begin Now!",
      "Our Magic, Your Journey - Get Started!",
      "Seek Adventures, Not WiFi - Get Going Today!",
      "Explore More, Stress Less - Begin Your Trip Now!",
      "Your Road, Your Story - Plan a Road Trip Today!"
  ];

  const randomIndex: number = Math.floor(Math.random() * hooks.length);
  const randomHook: string = hooks[randomIndex];

  $('[featureHook]').text(randomHook);
};

$(document).on("click", "[data-bs-target='#signupModal'],[popupTrigger='freemiumShowSignup']", function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  $(".modal").modal("hide");
  if(window.featureFlags.freemiumShowCardedTrial == null){
    getAllFeatureFlags().then(() => {
      freemiumShowSignup(this)
    })
  }else{
    freemiumShowSignup(this)
  }
});

$(document).on("click", "[popupTrigger='freemiumShowSubscribe']", function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  $(".modal").modal("hide");
  if(window.featureFlags.freemiumShowCardedTrial == null){
    getAllFeatureFlags().then(() => {
      freemiumShowSubscribe(this)
    })
  }else{
    freemiumShowSubscribe(this)
  }
});

$(document).on("change", "[dist-unit-select]", function() {
  $("[dist-unit-select]").not(this).val(this.value);
  switch(this.value) {
    case "mi":
      if ($("#driveDist").length) {
        $("#driveDist").val(Math.round(meter_to_mi(parseInt($("#driveDist").val().toString())*1000)));
      } else if ($("[drive-dist]").length) {
        $("[drive-dist]").val(Math.round(meter_to_mi(parseInt($("[drive-dist]").val().toString())*1000)));
      };

      $("[driveDistOption-label]").each(function(idx,el) {
        $(el).html($(el).html().replace("Kilometers","Miles").replace("kilometers","miles"));
      });

      $(".dist-unit-suffix").html("mi");
      break;
    case "km":
      if ($("#driveDist").length) {
        $("#driveDist").val(Math.round(mi_to_meter(parseInt($("#driveDist").val().toString()))/1000))
      } else if ($("[drive-dist]").length) {
        $("[drive-dist]").val(Math.round(mi_to_meter(parseInt($("[drive-dist]").val().toString()))/1000))
      };
      $("[driveDistOption-label]").each(function(idx,el) {
        $(el).html($(el).html().replace("Miles","Kilometers").replace("miles","kilometers"));
      });

      $(".dist-unit-suffix").html("km");
      break;
    default:
      break;
  };
});

$(document).on("click", "[popupTrigger='freemiumShowCardedTrial']", function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  let msg:string|undefined|null = $(this).attr("msg");

  $(".modal").modal("hide");

  if (msg === undefined || msg === null) {
    msg = "to start planning awesome adventures!";
  } else if (msg.length > 0) {
    msg = msg[0].toLowerCase() + msg.slice(1);
    if (msg[msg.length - 1] == ",") {
      msg = msg.slice(0, -1);
    };
  };

  $("#freemium-carded-trial").find("[signUpMsg]").html(msg);
  $("#freemium-carded-trial").modal("show");
  try{
    //Google Analytics signup tracking (see how many times modal has opened)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'event': 'showCardedTrialPopup', 'showCardedTrialPopupParameters':{'message' : msg, 'page':window.location.href}});
  } catch (error){
    console.error(error.message)
  }
});

$('.card-header.min-height-featurecard').on('click', function() {
	let targetModal = $(this).siblings('.featureModal'); // Get the modal related to this specific card
	$(targetModal).modal('show'); // Use Bootstrap's modal show method
  $(".modal-backdrop").css("display","none");
});

$(document).on("change","#sortBy_cgSearch", function(){
  let sortBy:string = $(this).find(":selected").val() as string;
  sort_camp_card_list($("#camp_search_results > .campsiteCard_list_wrapper"),sortBy);
  initializeTooltips();
});

/*
DEPRECATED
$(document).on("click","[registerPopupTrigger]", function() {
	let msg:string = $(this).attr("msg");
	$("#signUpPopupText").html(msg);
  $("#needSubModal").modal("show")
});

$(document).on("click", "[subPopupTrigger]", function() {
  let msg:string = $(this).attr("msg");
  $("#subscribePopupText").html(msg);
  $("#modal-subscribe").modal("show");
});
*/

$(document).on("click", "[photoSec_photo]", () => {
	$("#photoSlidesPop").modal("show");
});

$(document).on("click", "#showMoreButton, #showMoreButton2, #showMoreButton_amen, #showMoreButton_amen2, #showMoreButton_activ", function(this: any){
  if($(this).attr("aria-expanded") == "true"){
    $(this).html("Show Less");
  }else{
    $(this).html("Show More");
  }
});

$(document).on("click", ".favorite-trigger", function(this: HTMLImageElement) {
  favorite_campsite(this, parseInt(this.id));
});

$(document).on("click", ".unfavorite-trigger", function(this:HTMLImageElement) {
  unfavorite_campsite_fromIcon(this, parseInt(this.id));
});

$(document).on("click","#seeMoreAmenities",function() {
  $(this).siblings("#amenityList").find("li.d-none").each(function() {
    $(this).removeClass("d-none");
  });

  $(this).siblings("#seeLessAmenities").removeClass("d-none");
  $(this).addClass("d-none");
});

$(document).on("click","#seeLessAmenities",function() {
  $(this).siblings("#amenityList").find("li:nth-child(n+9)").each(function() {
    $(this).addClass("d-none");
  });

  $(this).siblings("#seeMoreAmenities").removeClass("d-none");
  $(this).addClass("d-none");
});


$(document).on("click", ".agNavbar", function(){
	if ($('#campExpandedModal').hasClass('show')) {
		// If it is open, close it
		$('#campExpandedModal').modal('hide');
	}
});

$(document).on("shown.bs.modal", "#campExpandedModal", function() {

  $("#campExpandedModal a[href='#info']").tab("show");

  // initMap_campPage('campPageMap');

  // let markerLayer:Vector<Vector_src> = addMarkerLayer(window.map);
  let coordsEl:JQuery<HTMLElement> = $("#coords");
  let lat:number = parseFloat(coordsEl.find("#lat").html());
  let lon:number = parseFloat(coordsEl.find("#lon").html());
  // addPin_toMarkerLayer([lon,lat],markerLayer);
  // window.map.setView(new View({
  //   center: [lon,lat],
  //   zoom: 10,
  //   rotation: 0
  // }));

  initMap_googleMaps("g-campPageMap", "hybrid", lat, lon, 15).then(map => {
    addMarker_googleMap(map, lat, lon);
    $("#expandedCampListenerForPaddingAdjustment").removeClass("py-3");
    $("#expandedCampListenerForPaddingAdjustment").find(".container").removeClass("rounded");
    //initialize camp photo popup modal
    let mainPopupSplideList_El:JQuery<HTMLElement> = $("#photoSlidesPop_mainSplide").find(".splide__list");
    let thumbnailPopupSplideList_El:JQuery<HTMLElement> = $("#photoSlidesPop_thumbnailsSplide").find(".splide__list")

    let expandedCardSplideList_El:JQuery<HTMLElement> = $("#campPhotoCaro").find(".splide__list");

    if (mainPopupSplideList_El.length) {
      mainPopupSplideList_El.html(expandedCardSplideList_El.html());
      thumbnailPopupSplideList_El.html(expandedCardSplideList_El.html());

      var popup_main = new Splide(document.getElementById("photoSlidesPop_mainSplide") as HTMLElement);
      var popup_thumbnails = new Splide(document.getElementById("photoSlidesPop_thumbnailsSplide") as HTMLElement);
      popup_main.sync(popup_thumbnails);
      popup_main.mount();
      popup_thumbnails.mount();

      $("#photoSlidesPop").on("shown.bs.modal", () => {
        popup_main.emit("resize");
        popup_thumbnails.emit("resize");
      });
    };

    var elms = document.getElementById("campPhotoCaro");
    if (elms != null) new Splide( elms as HTMLElement ).mount();
    var elms = document.getElementById("campPhotoCaro2");
    if (elms != null) new Splide( elms as HTMLElement ).mount();
  });


});

//from lp
function checkVisible( elm: Element, evalType:string ) {
  evalType = evalType || "visible";

  var vpH = $(window).height(), // Viewport Height
    st = $(window).scrollTop(), // Scroll Top
    y = $(elm).offset().top,
    elementHeight = $(elm).height();

  if (evalType === "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
  if (evalType === "above") return ((y < (vpH + st)));
}

if (window.location.pathname === "/" || window.location.pathname == "") {

  //===

  //wwo feature play/pause implementation

    $(".FAQexpand").on("click", function(event:JQuery.ClickEvent){
      $(this).toggleClass("ai-arrow-down");
      $(this).toggleClass("ai-arrow-up");
    });

};

$(document).on("click","#index_loadMore",() => index_search_loadMore());

$("#missingCampground_report").on("click", () => {
  $("#missingCampground_modal").modal("show");
});



$("#missingCampground_form").on("submit", function(event){
  event.preventDefault();
  let campgroundName:string = $("#missing-cg-name").val().toString();
  let campgroundState:string = $("#missing-cg-state").val().toString();
  let campgroundURL:string = $("#missing-cg-url").val().toString();
  let campgroundCity:string = $("#missing-cg-city").val().toString();
  submit_missingCampground(campgroundName, campgroundState, campgroundURL, campgroundCity).then(()=>{
    $("#missingCampground_modal").modal("hide");
  }).catch(e => {
    console.error(e);
  });
});



$(document).on("click","a[href*='/rv-trips']", async (event:Event) => {
  //reset trip carousels so genie trips so in the correct order
  await waitFor(.5);
  genieTrip_splides.forEach(el => {
    el.emit("resize");
  });
});

var expandedFilters = false;

$(document).on("click", "#agSearchFilterSidebarButton", ()=>{
  if(!expandedFilters){
    $('#agSearchFilterSidebarButton').css("margin-left", $('#agSearchFilterSidebar').width());
    $('#agSearchFilterSidebar').css("left", "0");
    $('#agSearchFilterSidebar').addClass('show');
    $('.ai-chevrons-right').addClass('ai-chevrons-left');
    $('.ai-chevrons-left').removeClass('ai-chevrons-right');
    expandedFilters = true;
  }else if(expandedFilters){
    expandedFilters = false;
    $('.ai-chevrons-left').addClass('ai-chevrons-right');
    $('.ai-chevrons-right').removeClass('ai-chevrons-left');
    $('#agSearchFilterSidebar').css("left", "-1000px")
    $('#agSearchFilterSidebar').removeClass('show');
    $('#agSearchFilterSidebarButton').css("margin-left", 0);
  }
});

let genieTrip_splides:Array<Splide> = [];
let camp_splides:Array<Splide> = [];
let homepage_splides:Array<Splide> = [];

if (window.location.pathname == "/" || window.location.pathname == "" || window.location.pathname == "/campgrounds" || window.location.pathname == "/rv-trips" || window.location.pathname == "/plans") {
  $(function() {
    var elms = $("[genieTripSplide]");
    for ( var i = 0; i < elms.length; i++ ) {
      let splide:Splide = new Splide( elms[i] as HTMLElement ).mount();
      genieTrip_splides.push(splide);
    };

    var elms = $("[featuredInSplide]");
    for ( var i = 0; i < elms.length; i++ ) {
      let splide:Splide = new Splide( elms[i] as HTMLElement ).mount();
      genieTrip_splides.push(splide);
    };

    var elms = $("[homepageImageSplide]")
    for ( var i = 0; i < elms.length; i++ ) {
      let splide:Splide = new Splide( elms[i] as HTMLElement ).mount();
      homepage_splides.push(splide);
    };


    $('.plans-tab-item.pro-tab').on('click', function() {
      $('.plans-tab-container').removeClass('borderNone');
      $('.plans-tab-item').removeClass('active');
      $(this).addClass('active');
      $('.content-container > *').removeClass('active');
      $('.pro-content').addClass('active');
    });

    $('.plans-tab-item.basic-tab').on('click', function() {
      //check if .plans-tab-container does not have the class before adding it
      if(!$('.plans-tab-container').hasClass('borderNone')){
        $('.plans-tab-container').addClass('borderNone');
      }
      $('.plans-tab-item').removeClass('active');
      $(this).addClass('active');
      $('.content-container > *').removeClass('active');
      $('.basic-content').addClass('active');
    });

    if (document.getElementById("topCampsDisp")) {
      send_getTopCamps().then(topCampsHTML => {
        $("#topCampsDisp").html(topCampsHTML);
        var elms = document.getElementById("topCampsDisp").getElementsByClassName( 'campSplide' );
        for ( var i = 0; i < elms.length; i++ ) {
          let splide:Splide = new Splide( elms[i] as HTMLElement ).mount();
          camp_splides.push(splide);
        };
        camp_splides.forEach(el => {
          el.emit("resize");
        });
      });
    };
    if (document.getElementById("sponsoredCampsDisp")) {
      send_getTopSponsoredCamps().then(topSponsoredHTML => {
        $("#sponsoredCampsDisp").html(topSponsoredHTML);
        var elms = document.getElementById("sponsoredCampsDisp").getElementsByClassName( 'campSplide' );
        for ( var i = 0; i < elms.length; i++ ) {
          let splide:Splide = new Splide( elms[i] as HTMLElement ).mount();
          camp_splides.push(splide);
        };
        camp_splides.forEach(el => {
          el.emit("resize");
        });
      })
    };
    if (document.getElementById("likedCampsDisp")) {
      send_getLikedCamps().then(likedCampsHTML => {
        $("#likedCampsDisp").html(likedCampsHTML);
        var elms = document.getElementById("likedCampsDisp").getElementsByClassName( 'campSplide' );
        for ( var i = 0; i < elms.length; i++ ) {
          let splide:Splide = new Splide( elms[i] as HTMLElement ).mount();
          camp_splides.push(splide);
        };
        camp_splides.forEach(el => {
          el.emit("resize");
        });
      })
    }
  });
}



$(document).ready(function() {
  function updateTabState() {
    // For each <li> with class 'tabPro' or 'tabBasic'
    $('.tabPro, .tabBasic').each(function() {
      const li = $(this);
      const anchor = li.children('a');
      // If the anchor has the 'active' class and the <li> doesn't, add it to the <li>
      if (anchor.hasClass('active') && !li.hasClass('active')) {
        li.addClass('active');
      }
      // If the anchor doesn't have the 'active' class and the <li> does, remove it from the <li>
      if (!anchor.hasClass('active') && li.hasClass('active')) {
        li.removeClass('active');
      }
    });
  };

  // Call updateTabState function whenever a 'tabPro' or 'tabBasic' is clicked
  $('.tabPro, .tabBasic, .tabPro > a, .tabBasic > a').on('click', async function() {
    updateTabState();
    await(waitFor(0.1));
    updateTabState();
  });

  $("#signUp_cardedTrialModal, #memberCardedTrialModal").on("shown.bs.modal",function() {
    const attachRewardfulForms = () => {
      if (typeof Rewardful !== "undefined" && Rewardful.Forms) {
        Rewardful.Forms.attach();
        $(this).find("[name='affiliateID']").val(Rewardful.affiliate.id);
        clearInterval(interval);
      }
    };
    const interval = setInterval(attachRewardfulForms, 100);
  });

  $("#loginModal").on("shown.bs.modal",function() {
    const attachRewardfulForms = () => {
      if (typeof Rewardful !== "undefined" && Rewardful.Forms) {
        Rewardful.Forms.attach();
        $(this).find("[name='affiliateID']").val(Rewardful.affiliate.id);
        clearInterval(interval);
      }
    };

    const interval = setInterval(attachRewardfulForms, 100);
  });

  $("#signupModal").on("shown.bs.modal",function() {
    const attachRewardfulForms = () => {
      if (typeof Rewardful !== "undefined" && Rewardful.Forms) {
        Rewardful.Forms.attach();
        $(this).find("[name='affiliateID']").val(Rewardful.affiliate.id);
        clearInterval(interval);
      }
    };

    const interval = setInterval(attachRewardfulForms, 100);
  });
});

$(document).on('click',"#likeGenieSummary", () => {

  $("#likeGenieSummary").addClass("active");
  send_genieSummaryFeedback("like",1,$("#likeGenieSummary").attr("campID").toString());

  if ($("#dislikeGenieSummary").hasClass("active")) {
    $("#dislikeGenieSummary").removeClass("active");
    send_genieSummaryFeedback("dislike",-1,$("#likeGenieSummary").attr("campID").toString());
  };
});

$(document).on('click',"#dislikeGenieSummary",() => {

  $("#dislikeGenieSummary").addClass("active");
  send_genieSummaryFeedback("dislike",1,$("#dislikeGenieSummary").attr("campID").toString());

  if ($("#likeGenieSummary").hasClass("active")) {
    $("#likeGenieSummary").removeClass("active");
    send_genieSummaryFeedback("like",-1,$("#likeGenieSummary").attr("campID").toString());
  };
});


if (window.location.pathname == "" || window.location.pathname == "/") {
  $(document).on("focus", ".stop-by-stop-input", function(event) {
    $("#stop-by-stop-autofill").show();
    let $autofill_results:JQuery<HTMLElement> = $("#stop-by-stop-autofill").find("#autofill_results");
		if (! $autofill_results.html().length) $("#user-locations-wrapper").show();
    else $autofill_results.removeClass("d-none");
    let linkedInputElement:JQuery<HTMLElement> = $(event.target);
    window.curAutofillInput = linkedInputElement as JQuery<HTMLInputElement>;

    let firstStopOffset = $("#from").offset().left;
    
    $autofill_results.parent().css("left", (linkedInputElement.offset().left - firstStopOffset));
    $autofill_results.parent().css("top", linkedInputElement.parent().position().top + linkedInputElement.outerHeight());
  });

  $(document).on("focusout", ".stop-by-stop-input", ()=>{$("#stop-by-stop-autofill:not(:hover)").hide();});

  let typingTimer: ReturnType<typeof setTimeout>;
	const doneTypingInterval = 250;
	$(document).on("keydown", ".stop-by-stop-input", (event: JQuery.KeyboardEventBase<any, any, any, any>) => {
		if (event.key == "Enter" || event.key == "Escape" || event.key == "Tab") {
			$("#stop-by-stop-autofill").hide();
		};
		clearTimeout(typingTimer);
		typingTimer = setTimeout(function() {
			$(".stop-by-stop-input").off("keydown");

			StopByStopTrip_autofill(event);
		}.bind(this),doneTypingInterval);
	});

  $(document).on("click", "#useHome", function() {
		let address:string = $("#useHome").attr("data");
		window.curAutofillInput.val(address);
		$("#stop-by-stop-autofill").hide();
	});

  $(document).on("click", "#getLocation", ()=> {
		if (!navigator.geolocation) {
			console.error(`Your browser doesn't support Geolocation`);
		}else{
			navigator.geolocation.getCurrentPosition((position)=>{
				window.curAutofillInput.attr("query_type","poi");
				window.curAutofillInput.attr("query_val", `${position.coords.latitude},${position.coords.longitude}`)


				reverseGeocode(position.coords.latitude, position.coords.longitude).then((address: any) => {
					// $('#startLocation').val(address);
					window.curAutofillInput.val(address);
					$("#stop-by-stop-autofill").hide();
				}).catch(e => {
					$("#exception_str").val(e.toString());
					$("#errorModal").modal("show");
				});
			}), ()=>{
				console.error(`Failed to get Geolocation`);
			};
		}
	});

  $("#mobileNavBackground").on("click", function() {
    if(!($("header").hasClass("bg-white"))) {
      $("header").addClass("bg-white").removeClass("mt-4");
      $(this).find("img").attr("src","/static/images/logo/logo-icon.webp");
      $(this).find("a.position-absolute").css("color","#2A2550");
    } else {
      $("header").removeClass("bg-white").addClass("mt-4");
      $(this).find("img").attr("src","/static/images/logo/AdventureGenie_ICON_allWhite.svg");
      $(this).find("a.position-absolute").css("color","white");
    }
  });

  $(document).on("click","#takeGenieTrip-openSettings", function(event) {
    event.preventDefault();
    event.stopPropagation();

    let genieTripSettings_modal = $("#takeGenieTrip_modal");
    genieTripSettings_modal.find(".modal-title[takeTripAllowed]").html("");
    genieTripSettings_modal.find(".modal-title[takeTripAllowed]").html(`Configure Your Route Preferences for:</br><em>${$(this).parent().find("#genieTrip_tripName").html()}</em>`);
    
    genieTripSettings_modal.find("#genieTrip-startLABEL").html("");
    genieTripSettings_modal.find("#genieTrip-endLABEL").html("");
    genieTripSettings_modal.find("#genieTrip-startLABEL").html(`Trip Start - <i>${$(this).parent().find(".destination-coord#0").attr("dest_str")}</i>`);
    genieTripSettings_modal.find("#genieTrip-endLABEL").html(`Trip End - <i>${$(this).parent().find(".destination-coord").last().attr("dest_str")}</i>`);
    
    genieTripSettings_modal.modal("show");
  });

  $("#takeGenieTrip-showSub").on("click", function(event) {
    event.preventDefault();
    event.stopPropagation();

    $("#modal-subscribe").modal("show");
  });

  $("#takeGenieTrip").on("click", function():void {

    console.log("clicked takeGenieTrip");
    let stopSetCoords:Array<{
      id:number,
      lat:number,
      lon:number,
      dest_str:string,
      geo_str:string
    }> = [];
    let stopSetData_el:JQuery<HTMLElement> = $("#stopSet");
    let stopSetCoords_els:JQuery<HTMLElement> = stopSetData_el.find(".destination-coord");
  
    let driveTime:number;
    let driveTime_str:string;
    let routeWidth:number;
    let avoidHighways:number;
  
    let routeStart_query:string = $("#genieTrip-start").val().toString();
    let routeEnd_query:string = $("#genieTrip-end").val().toString();
  
    let routeStart_query_type:string|null = $("#genieTrip-start").attr("query_type");
    let routeStart_query_val:string|null = $("#genieTrip-start").attr("query_val");
  
    let routeEnd_query_type:string|null = $("#genieTrip-end").attr("query_type");
    let routeEnd_query_val:string|null = $("#genieTrip-end").attr("query_val");
  
    let isFantasyTour:string = $("#isFRVTTour").val().toString();
    if (routeStart_query_type == undefined || routeStart_query_val == undefined || routeStart_query.length <= 1) {
      routeStart_query_type = null;
      routeStart_query_val = null;
      $("#genieTrip-start").val("");
    };
  
    if (routeEnd_query_type == undefined || routeEnd_query_val == undefined || routeEnd_query.length <= 1) {
      routeEnd_query_type = null;
      routeEnd_query_val = null;
      $("#genieTrip-end").val("");
    };
  
    if ($("#drive-time").length) driveTime_str = $("#drive-time").val().toString();
    else driveTime_str = "";
    if (driveTime_str.length == 0) {
      //set default time 6hrs
      driveTime_str = "06:00";
    };
  
    let driveDist:number|string = $("#drive-dist").val() as number|string;
    if (typeof(driveDist) == "string") {
      driveDist = parseInt(driveDist);
    };
    if (Number.isNaN(driveDist)) {
      driveDist = 300;
      $("#drive-dist").val(driveDist);
    };
  
    if ((driveTime = check_driveTimeStr_getNum(driveTime_str)) == 0) return null;
  
    routeWidth = parseInt($("input[name='route-width']:checked").val().toString());
  
    //TODO: uncomment this if we add avoid-highways option on genie trips screen
    avoidHighways = 0;
  
    stopSetCoords_els.each(function() {
      stopSetCoords.push({
        id: parseInt($(this).attr("id")),
        lat: parseFloat($(this).attr("lat")),
        lon: parseFloat($(this).attr("lon")),
        dest_str: encodeURIComponent($(this).attr("dest_str")),
        geo_str: encodeURIComponent($(this).attr("geo_str")),
      });
    });
  
    if ((stopSetCoords.length == 1) && ((routeStart_query === "") || (routeEnd_query === ""))) {
      $("[trip_errEl]").find("[errMsg]").html("Please add a start and end destination to take this trip.");
      $("[trip_errEl]").removeClass("d-none");
      return
    };
  
    let tripID:string = $("#tripID").val() as string;
  
    let trip_url_encoded:string = `/tripPlanner?genieTrip=${JSON.stringify(stopSetCoords)}&tripID=${tripID}&driveTime=${driveTime}&driveDist=${driveDist}&routeWidth=${routeWidth}&avoidHighways=${avoidHighways}&isFRVT=${isFantasyTour}`;
  
    if (routeStart_query != "" && routeStart_query.length > 1) trip_url_encoded += `&start=${routeStart_query}&start_query_type=${routeStart_query_type}&start_query_val=${routeStart_query_val}`;
  
    if (routeEnd_query != "" && routeEnd_query.length > 1) trip_url_encoded += `&end=${routeEnd_query}&end_query_type=${routeEnd_query_type}&end_query_val=${routeEnd_query_val}`;
  
    let pathname_split:Array<string> = window.location.pathname.split("/");
    let trip_url_ext:string = pathname_split[pathname_split.length - 1];
  
    takeGenieTrip_log(trip_url_ext);
    console.log(trip_url_encoded);
    window.location.href = window.location.origin + trip_url_encoded;
  });

};

$(".tab-content").on("submit", "form[id^='homePage_tpSearch']", function (e) {
  e.preventDefault();

  const $form = $(this); // the submitted form (desktop or mobile)
  const $from = $form.find("input[name='from']");
  const $to = $form.find("input[name='to']");
  const $driveDist = $form.find("input[name='driveDist']");
  const $unitSelect = $form.find("input[name='distUnit']:checked");

	
  const dist_unit: string = $unitSelect.length ? $unitSelect.val()?.toString() ?? "mi" : "mi";
  const driveDist: number = parseInt($driveDist.val() as string);
  const from_query_type: string | undefined = $from.attr("query_type");
  const from_query_val: string | undefined = $from.attr("query_val");
  const from_text: string = encodeURIComponent($from.val() as string).replace(/\r?\n/g, " ");

  const to_query_type: string | undefined = $to.attr("query_type");
  const to_query_val: string | undefined = $to.attr("query_val");
  const to_text: string = encodeURIComponent($to.val() as string).replace(/\r?\n/g, " ");

  let from_query_arg_components:string[];
  if (from_query_type != undefined && from_query_val != undefined) {
    from_query_arg_components = [
      from_query_type,
      encodeURIComponent(from_query_val),
      from_text
    ];
  } else {
    from_query_arg_components = [from_text]
  };
  let to_query_arg_components:string[];
  if (to_query_type != undefined && to_query_val != undefined) {
    to_query_arg_components = [
      to_query_type,
      encodeURIComponent(to_query_val),
      to_text
    ];
  } else {
    to_query_arg_components = [to_text]
  };

  const query_args = encodeURI(`?stops=${from_query_arg_components.join()}|${to_query_arg_components.join()}&driveDist=${driveDist}&unit=${dist_unit}&submit=true`);

  window.location.href = `/tripPlanner${query_args}`;
});

function setupGenieSearch(inputId: string, buttonId: string) {
  $(`#${inputId}`).on("keydown", function (event: JQuery.KeyDownEvent) {
    if (event.key === "Enter") {
      event.preventDefault();
      $(`#${buttonId}`).trigger("click");
    }
  });

  $(`#${buttonId}`).on("click", function () {
    const inputEl = document.getElementById(inputId) as HTMLTextAreaElement;
    const search = inputEl.value;
    const query_args = encodeURI(`?genieJourney=${encodeURIComponent(search)}&submit=true`);
    window.location.href = `/tripPlanner${query_args}`;
  });
}

setupGenieSearch("allInOneSearchDesktop", "searchGenieJourneyDesktop");
setupGenieSearch("allInOneSearchMobile", "searchGenieJourneyMobile");

if (window.location.pathname === "/" || window.location.pathname == "/campgrounds" || window.location.pathname.includes("/rv-trips") || window.location.pathname == "/fantasy-rv-tours-catalog") {
  const $nav = $(".agNewNavBar");
  const $logo = $("#navLogo");
  const $navItems = $(".agNewNavItem");
  const $hamburger = $(".AGhamburger");
  const $mobileMenu = $(".AGmobile-menu");

  let hoveringNav = false;
  let lastScrollTop = 0;
  let scrollDirection: "up" | "down" = "up";
  let menuJustClosed = false;

  function isMobile(): boolean {
    return window.innerWidth <= 882;
  }

  function updateScrollDirection(): void {
    const st = $(window).scrollTop() || 0;
    scrollDirection = st > lastScrollTop ? "down" : "up";
    lastScrollTop = st;
  }

  function atTop(): boolean {
    return $(window).scrollTop() === 0;
  }

  function updateNavState(): void {
    updateScrollDirection();
    const mobile = isMobile();
    const menuOpen = $mobileMenu.hasClass("active");
    const top = atTop();
  
    if (!mobile) {
      $nav.removeClass("has-menu-open");
    }
  
    if (menuOpen) {
      if (scrollDirection === "down") {
        $mobileMenu.removeClass("active");
        $nav.css("opacity", "0");
        return;
      }
      applyWhiteNav();
      return;
    }
  
    if (mobile && menuJustClosed) {
      menuJustClosed = false;
      if (atTop()) {
        applyTransparentNav();
      } else {
        applyWhiteNav();
      }
      return;
    }
  
    if (scrollDirection === "down" && !top) {
      $nav.css("opacity", "0");
      return;
    }
  
    if (scrollDirection === "up" && !top) {
      $nav.css("opacity", "1");
      applyWhiteNav();
      return;
    }
  
    if (top) {
      $nav.css("opacity", "1");
      applyTransparentNav();
    }
  }

  function applyWhiteNav(): void {
    $nav.removeClass("navbg-transparent").addClass("navbg-white");
    $navItems.each(function () {
      (this as HTMLElement).style.setProperty("color", "", "important");
    });
  
    if (isMobile()) {
      $logo.attr("src", "/static/images/logo/logo-icon.webp");
      $logo.css("width", "48px");
    } else {
      $logo.attr("src", "/static/images/logo/logo-dark.webp");
      $logo.css("width", ""); // <-- REMOVE desktop width setting
    }
  }
  
  function applyTransparentNav(): void {
    $nav.removeClass("navbg-white").addClass("navbg-transparent");
    $navItems.each(function () {
      (this as HTMLElement).style.setProperty("color", "white", "important");
    });
  
    if (isMobile()) {
      $logo.attr("src", "/static/images/logo/AdventureGenie_ICON_allWhite.svg");
      $logo.css("width", "48px");
    } else {
      $logo.attr("src", "/static/images/logo/AdventureGenie_long_ALLWHITE.svg");
      $logo.css("width", ""); // <-- REMOVE desktop width setting
    }
  }
  $hamburger.on("click", function () {
    const wasOpen = $mobileMenu.hasClass("active");
    $mobileMenu.toggleClass("active");
  
    if (!wasOpen) {
      $nav.addClass("has-menu-open");
    } else {
      $nav.removeClass("has-menu-open");
      menuJustClosed = true;
      if (atTop()) applyTransparentNav();
    }
  
    setTimeout(updateNavState, 0);
  });

  $nav.on("mouseenter", () => {
    if (atTop() && !isMobile() && !hoveringNav) {
      hoveringNav = true;
      applyWhiteNav();
    }
  });
  
  $nav.on("mouseleave", () => {
    if (atTop() && !isMobile()) {
      hoveringNav = false;
      applyTransparentNav();
    }
  });

  $(window).on("scroll resize", updateNavState);
  updateNavState();
}